import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackPageView } from '@/lib/metaPixel';
import { guardarAtribucionDeLaUrl } from '@/lib/atribucion';

// Fires Meta Pixel init once and tracks PageView on every route change.
// También guarda fbclid/UTM de la URL para mandarlos con la compra.
export default function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    initMetaPixel();
  }, []);

  useEffect(() => {
    guardarAtribucionDeLaUrl();
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
